import { getAccountByLogin } from '@/db/accountService'
import { calculateFingerprint } from '@/services/fingerprint'
import { decryptMessage } from '@/services/cryptoUtils'

export async function getHomeAuthToken(login) {
    const account = await getAccountByLogin(String(login))
    if (!account) throw new Error('No stored account credentials')
    const fingerprint = await calculateFingerprint()
    return decryptMessage(account.token, fingerprint, account.iv)
}

export function getHomeCapacity(home) {
    const photoLimit = home?.limits?.photos || 0
    const vehicleLimit = home?.limits?.vehicles || 0
    return {
        photoLimit,
        vehicleLimit,
        canAddPhoto: (home?.photos?.length || 0) < photoLimit,
        showVehicles: vehicleLimit > 0,
        canAddVehicle: (home?.vehicles?.length || 0) < vehicleLimit,
    }
}
